import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width:900px)" ) ]

const slider = {
  obj: '[data-plugin="slider"]',
  animationDuration: 8000,
  init() {
    $(this.obj).slick({
      autoplay: true,
      fade: true,
      dots: true,
      speed: 2000,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
    $(this.obj).on('beforeChange', (e, slick, cs, ns) => {
      $(`[data-slick-index=${ns}]`).addClass('is-animation-start')
      setTimeout(() => $(`[data-slick-index=${ns}]`).removeClass('is-animation-start'),
        this.animationDuration
      )
    })
  },
  start() {
    $(this.obj).slick('slickPlay').addClass('is-slickPlay')
    $(`[data-slick-index=0]`).addClass('is-animation-start')
    setTimeout(() => $(`[data-slick-index=0]`).removeClass('is-animation-start'),
      this.animationDuration
    )
  }
}

const init = () => {
  // slick実行
  w.load['mainvisual'].then( () => {
    slider.init(), slider.start()
  })

  //ticker
  $.when( w.load['block-ticker'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">【${item.category.name}】</span>
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem })
  })

  // products
  $.when( w.load['block-products'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="block-products-item">
       <span class="cat">${item.category.name}</span>
       <figure class="block-products-item__img">
          <div class="block-products-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="300" loading="lazy"></div>
        </figure>
        <div class="block-products-item__body">
          <h4 class="subject">
            ${item.title.str_truncate(24)}${item.is_new ? '<span class="is-new">NEW</span>': ''}
          </h4>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-products__list[data-plugin="getArticles"]',{ makeItem })
  })

  //news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <span class="cat">【${item.category.name}】</span>
          <span class="date">${item.date}</span>
          <span class="subject ${item.is_new ? 'is-new': ''}">${item.title.str_truncate(24)}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES( '.block-news__list[data-plugin="getArticles"]', { makeItem })
  })

}

export default function HOME() {
  $( init )
}